import { mergeStyleSets, Spinner, SpinnerSize, Text } from '@fluentui/react';

export const LoggingIn: React.FC = () => {
  const styles = mergeStyleSets({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      flexDirection: 'column',
    },
    loginLabel: {
      paddingTop: 8,
    },
  });

  return (
    <div className={styles.wrapper}>
      <Spinner size={SpinnerSize.large} />
      <Text className={styles.loginLabel} variant="medium">
        Logging in...
      </Text>
    </div>
  );
};
